import React from 'react';
import { FuelTypography } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import { formatPlate } from '@utils/formatters';
import * as StyledModal from '../../ModalMonitoringStyles';
import Detail from './Detail';
import { SectionPropsInterface } from './SectionTypes';

function Section({ infos, title }: SectionPropsInterface) {
  function renderDetails() {
    const details: React.ReactNode[] = [];

    if (infos.type === 'cargo') {
      details.push(
        <Detail
          key={`details-pickup-${infos.data.pickup.at}`}
          title="Coleta"
          description={infos.data.pickup.at}
        />,
        <Detail
          key={`details-delivery-${infos.data.delivery.at}`}
          title="Entrega"
          description={infos.data.delivery.at}
        />,
        <Detail
          key={`details-product-${infos.data.product}`}
          title="Produto"
          description={infos.data.product}
        />,
        <Detail
          key={`details-value-${infos.data.value}`}
          title="Valor da mercadoria"
          description={infos.data.value}
        />,
      );
    }

    if (infos.type === 'vehicle') {
      const plate =
        infos.data.plate.length > 1
          ? formatPlate(infos.data.plate)
          : infos.data.plate;

      details.push(
        <Detail
          key={`details-type-${infos.data.type}`}
          title="Veículo"
          description={infos.data.type}
        />,
        <Detail
          key={`details-bodywork-${infos.data.bodywork}`}
          title="Carroceria"
          description={infos.data.bodywork}
        />,
        <Detail
          key={`details-plate-${infos.data.plate}`}
          title="Placa"
          description={plate}
        />,
      );
    }

    if (infos.type === 'payment') {
      details.push(
        <Detail
          key={`details-advance-${infos.data.advance}`}
          title="Adiantamento"
          description={infos.data.advance}
        />,
        <Detail
          key={`details-balance-${infos.data.balance}`}
          title="Saldo"
          description={infos.data.balance}
        />,
        <Detail
          key={`details-extras-${infos.data.extras}`}
          title="Custos extras"
          description={infos.data.extras}
        />,
        <Detail
          key={`details-paidOut-${infos.data.paidOut}`}
          title="Valor pago"
          description={infos.data.paidOut}
        />,
      );
    }

    return (
      <FuelFlex
        defaultProps={{
          gap: 'km4',
        }}
        smProps={{
          flexDirection: 'column',
        }}
      >
        {details}
      </FuelFlex>
    );
  }

  return (
    <StyledModal.Section hasDivider data-testid="monitoring-section-details">
      <FuelTypography tag="h3" weight="bold">
        {title}
      </FuelTypography>
      {renderDetails()}
    </StyledModal.Section>
  );
}

export default Section;
